import Cookies from 'js-cookie'

const COOKIE_NAME = 'utmz'
const COOKIE_OPTIONS = { expires: 30 }
const EMPTY_UTM = 'utmcsr=|utmccn=|utmcmd=|utmcct=|utmctr=|'

const SEARCH_ENGINES = [
  { pattern: /google\./i,    source: 'google'     },
  { pattern: /bing\.com/i,   source: 'bing'       },
  { pattern: /yahoo\.com/i,  source: 'yahoo'      },
  { pattern: /duckduckgo/i,  source: 'duckduckgo' },
  { pattern: /baidu\.com/i,  source: 'baidu'      },
]

const SOCIAL_NETWORKS = [
  { pattern: /facebook\.com|fb\.com/i,  source: 'facebook'  },
  { pattern: /instagram\.com/i,         source: 'instagram' },
  { pattern: /twitter\.com|t\.co\//i,   source: 'twitter'   },
  { pattern: /x\.com/i,                 source: 'x'         },
  { pattern: /linkedin\.com/i,          source: 'linkedin'  },
  { pattern: /youtube\.com|youtu\.be/i, source: 'youtube'   },
  { pattern: /tiktok\.com/i,            source: 'tiktok'    },
  { pattern: /pinterest\.com/i,         source: 'pinterest' },
]

const searchParams = new URLSearchParams(location.search)

function getParam(name) {
  return searchParams.get(name) || ''
}

function buildUTMString({ source, medium, campaign, content, term }) {
  return `utmcsr=${source}|utmccn=${campaign}|utmcmd=${medium}|utmcct=${content}|utmctr=${term}|`
}

function getLegacyParameters() {
  const adwordsSource = getParam('source')
  const adwordsMedium = getParam('medium')
  const adwordsGroup  = getParam('adgroup')

  const source = adwordsSource ? 'adwords' : getParam('utm_source')

  let medium = adwordsMedium ? `medium-${adwordsMedium}` : getParam('utm_medium')
  if (adwordsSource) medium = `${medium},source-${adwordsSource}`

  let campaign = getParam('campaign') ? `campaign-${getParam('campaign')}` : getParam('utm_campaign')
  if (adwordsGroup) campaign = `${campaign},adgroup-${adwordsGroup}`

  const content = getParam('kw') || getParam('utm_content')
  const term = getParam('utm_term')

  return { source, medium, campaign, content, term }
}

function hasLegacyParameters({ source, medium, campaign, content }) {
  return Boolean(source || medium || campaign || content)
}

function getReferrerHostname() {
  try {
    return new URL(document.referrer).hostname
  } catch {
    return ''
  }
}

function isExternalReferrer(hostname) {
  return (
    Boolean(hostname) &&
    hostname !== window.location.hostname &&
    !hostname.endsWith(`.${window.location.hostname}`)
  )
}

function classifyFromReferrer() {
  const hostname = getReferrerHostname()
  if (!isExternalReferrer(hostname)) return null

  const engine = SEARCH_ENGINES.find(({ pattern }) => pattern.test(hostname))
  if (engine) return { source: engine.source, medium: 'organic', campaign: '', content: '', term: '' }

  const social = SOCIAL_NETWORKS.find(({ pattern }) => pattern.test(hostname))
  if (social) return { source: social.source, medium: 'social', campaign: '', content: '', term: '' }

  return { source: hostname, medium: 'referral', campaign: '', content: '', term: '' }
}

function classifyTrafficSource() {
  const legacy = getLegacyParameters()
  if (hasLegacyParameters(legacy)) return legacy

  if (getParam('gclid'))  return { source: 'google',   medium: 'cpc',         campaign: '', content: '', term: '' }
  if (getParam('fbclid')) return { source: 'facebook', medium: 'paid_social', campaign: '', content: '', term: '' }

  return classifyFromReferrer() || { source: '(direct)', medium: '(none)', campaign: '', content: '', term: '' }
}

function isFullTrackingEnabled() {
  const meta = document.querySelector('meta[name="full_traffic_tracking"]')
  return meta !== null && meta.content === 'true'
}

function saveCookie(value) {
  Cookies.set(COOKIE_NAME, value, COOKIE_OPTIONS)
}

export function createCookieUTM() {
  if (!isFullTrackingEnabled()) {
    const legacy = getLegacyParameters()
    if (hasLegacyParameters(legacy)) saveCookie(buildUTMString(legacy))
    return
  }

  const classification = classifyTrafficSource()
  const isDirect = classification.source === '(direct)'
  const existingCookie = Cookies.get(COOKIE_NAME)

  if (isDirect) {
    if (!existingCookie) saveCookie(EMPTY_UTM)
    return
  }

  saveCookie(buildUTMString(classification))
}

export default function getUTM() {
  return Cookies.get(COOKIE_NAME) || buildUTMString(classifyTrafficSource())
}
